var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlasmaRifle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M109.97 6.97338C109.613 6.66738 106.019 5.63238 106.019 5.63238L100.063 5.75088C100.063 5.75088 94.1092 7.15188 92.7562 7.34238C91.4032 7.53288 91.3222 6.64488 91.3222 6.64488L80.9047 5.37738L79.6597 3.35088C79.6597 3.35088 51.5377 1.71588 43.8742 1.93638C36.2107 2.15688 22.6492 6.13788 22.6492 6.13788L20.3693 10.1924L14.2883 14.6264L13.7812 19.2854L14.6903 20.7059L16.0627 21.9899H17.7098L18.8917 25.6889H19.9058L20.4967 24.9329L20.3273 21.7784L20.4967 20.7074L28.0987 19.6964V31.6064L29.3662 37.9409C29.3662 37.9409 21.4267 36.3749 21.3637 36.2759C21.3007 36.1769 20.7502 32.2814 20.7502 32.2814L19.2292 32.8724L18.0473 36.3749L16.9493 37.6874L15.8513 37.8569C15.8513 37.8569 15.5603 39.3839 15.4643 40.4474C15.3683 41.5109 15.6397 42.8639 16.2877 44.5304C16.9357 46.1969 21.0727 48.7544 21.9202 49.5134C22.7677 50.2739 24.6832 52.3064 24.6832 52.3064C24.6832 52.3064 46.8517 55.0004 50.1127 55.2869C53.3737 55.5719 63.0682 55.6409 63.0682 55.6409L64.7377 55.2869L66.1927 54.1604L72.1342 53.1749L73.4272 53.9054L84.8497 57.4544L87.5647 56.5259L86.8042 55.9349L87.0577 53.8229L82.3492 52.3079L87.5437 51.3734L90.0142 49.0934L90.2677 48.0794L71.9377 42.5039L71.6002 41.4899C71.2627 40.4759 70.5592 40.3499 70.5592 40.3499L62.3737 39.0794C62.3737 39.0794 65.6032 34.7759 65.0962 32.3459C64.5892 29.9174 63.7027 28.1699 63.7027 28.1699L61.0657 21.7304L59.8222 18.6929C59.8222 18.6929 81.4507 16.6769 83.5417 16.6769C85.6327 16.6769 109.57 12.9824 109.57 12.9824L107.162 9.94188L108.992 9.75888C108.992 9.75888 109.696 9.68838 110.177 8.82888C110.657 7.96938 110.33 7.28238 109.973 6.97638L109.97 6.97338ZM53.2687 39.7994C53.2687 39.7994 50.9032 39.6299 49.2982 39.3764C47.6932 39.1229 41.4547 36.7574 41.4547 36.7574L39.8377 36.8414L37.5578 37.9394L35.1082 37.8554V38.8694L31.3912 38.2784L29.6167 31.1834L29.1098 21.7784L29.6167 19.1894L32.2357 18.4289L34.1783 20.7074H49.3822C49.3822 20.7074 50.6497 23.1599 52.1692 26.6219C53.6902 30.0854 53.9437 31.0994 54.0277 32.3654C54.1117 33.6329 53.2672 39.7979 53.2672 39.7979L53.2687 39.7994Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4912 38.1058C53.4912 38.1058 56.2257 39.3688 59.0127 38.1058C61.7997 36.8428 61.6317 35.4073 62.7297 35.2378C63.8277 35.0683 63.9552 36.3748 63.9552 36.3748",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2835 31.7743C54.2835 31.7743 58.9575 30.7048 57.9435 26.6503C56.9295 22.5958 52.1745 22.7728 50.949 23.9233",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9436 26.6503L63.0691 27.4918",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0042 19.2868C50.0042 19.2868 54.6782 18.2593 56.8172 20.0053C58.9577 21.7513 59.7932 21.9313 61.0637 21.7288",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7158 13.4443H35.8138H47.4973",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8145 13.4443L37.7855 15.3028V18.0058C37.7855 18.0058 37.739 18.8398 36.9905 18.8398C36.3995 18.8398 36.0515 18.4273 36.0395 18.0058C36.029 17.6143 36.377 17.2168 36.8 17.1898V14.3743",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8486 14.3743L34.8341 15.3028V18.0058C34.8341 18.0058 34.7876 18.8398 34.0391 18.8398C33.4481 18.8398 33.1001 18.4273 33.0881 18.0058C33.0776 17.6143 33.4256 17.2168 33.8486 17.1898V14.3743",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 13.4443L40.471 15.3028V18.0058C40.471 18.0058 40.4245 18.8398 39.676 18.8398C39.085 18.8398 38.737 18.4273 38.725 18.0058C38.7145 17.6143 39.0625 17.2168 39.4855 17.1898V14.3743",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1885 13.4443L43.1595 15.3028V18.0058C43.1595 18.0058 43.113 18.8398 42.3645 18.8398C41.7735 18.8398 41.4255 18.4273 41.4135 18.0058C41.403 17.6143 41.751 17.2168 42.174 17.1898V14.3743",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.875 13.4443L45.846 15.3028V18.0058C45.846 18.0058 45.7995 18.8398 45.051 18.8398C44.46 18.8398 44.112 18.4273 44.1 18.0058C44.0895 17.6143 44.4375 17.2168 44.8605 17.1898V14.3743",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5625 13.4443L48.5335 15.3028V18.0058C48.5335 18.0058 48.487 18.8398 47.7385 18.8398C47.1475 18.8398 46.7995 18.4273 46.7875 18.0058C46.777 17.6143 47.125 17.2168 47.548 17.1898V14.3743",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.373 39.0763L61.9425 42.7543L53.2695 39.7993",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6221 51.7048L79.9651 52.1203L82.3486 52.3048",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1172 53.2289L79.9647 52.1204",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5557 53.5768L81.4032 52.4683",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8389 53.9923L82.6864 52.8838",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1162 54.4574L83.9637 53.3489",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5254 54.8712L85.3744 53.7612",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9561 55.2853L86.8036 54.1768",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5361 53.1447L78.3836 52.0347",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0125 11.3323V12.9103H85.3105V11.0518",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0977 12.9103V15.6943",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5322 11.3323H98.4882",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9831 10.0828L98.2061 14.3023",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M51.959 10.5417L53.0165 12.1932H59.3525L60.506 10.5417",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8308 14.0789L29.1123 15.8519H30.2523L30.6333 14.9654L29.8308 14.0789Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9849 9.89673L31.8574 10.9527L33.0889 11.5857L34.2649 11.1642L31.9849 9.89673Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6092 8.20779L51.9587 8.37729L52.1162 9.24879L51.6092 9.75579L50.5667 9.16479V8.51679L51.6092 8.20779Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4314 10.1924V9.24886L60.8164 8.57386V7.55986L61.4314 7.10986L62.3734 8.20786V10.5419",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7992 13.6768C50.9276 13.6768 51.0317 13.5727 51.0317 13.4443C51.0317 13.3159 50.9276 13.2118 50.7992 13.2118C50.6707 13.2118 50.5667 13.3159 50.5667 13.4443C50.5667 13.5727 50.6707 13.6768 50.7992 13.6768Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8839 16.1427C52.0123 16.1427 52.1164 16.0386 52.1164 15.9102C52.1164 15.7818 52.0123 15.6777 51.8839 15.6777C51.7555 15.6777 51.6514 15.7818 51.6514 15.9102C51.6514 16.0386 51.7555 16.1427 51.8839 16.1427Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5345 20.9383C55.6629 20.9383 55.767 20.8342 55.767 20.7058C55.767 20.5774 55.6629 20.4733 55.5345 20.4733C55.4061 20.4733 55.302 20.5774 55.302 20.7058C55.302 20.8342 55.4061 20.9383 55.5345 20.9383Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7823 36.7409C58.9107 36.7409 59.0148 36.6368 59.0148 36.5084C59.0148 36.38 58.9107 36.2759 58.7823 36.2759C58.6539 36.2759 58.5498 36.38 58.5498 36.5084C58.5498 36.6368 58.6539 36.7409 58.7823 36.7409Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3731 48.7108C62.5015 48.7108 62.6056 48.6067 62.6056 48.4783C62.6056 48.3499 62.5015 48.2458 62.3731 48.2458C62.2447 48.2458 62.1406 48.3499 62.1406 48.4783C62.1406 48.6067 62.2447 48.7108 62.3731 48.7108Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0147 25.4189C59.1431 25.4189 59.2472 25.3148 59.2472 25.1864C59.2472 25.058 59.1431 24.9539 59.0147 24.9539C58.8863 24.9539 58.7822 25.058 58.7822 25.1864C58.7822 25.3148 58.8863 25.4189 59.0147 25.4189Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4356 28.7414C59.564 28.7414 59.6681 28.6373 59.6681 28.5089C59.6681 28.3805 59.564 28.2764 59.4356 28.2764C59.3072 28.2764 59.2031 28.3805 59.2031 28.5089C59.2031 28.6373 59.3072 28.7414 59.4356 28.7414Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0675 42.9867C35.1959 42.9867 35.3 42.8826 35.3 42.7542C35.3 42.6258 35.1959 42.5217 35.0675 42.5217C34.9391 42.5217 34.835 42.6258 34.835 42.7542C34.835 42.8826 34.9391 42.9867 35.0675 42.9867Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5528 47.0639C37.6812 47.0639 37.7853 46.9598 37.7853 46.8314C37.7853 46.703 37.6812 46.5989 37.5528 46.5989C37.4244 46.5989 37.3203 46.703 37.3203 46.8314C37.3203 46.9598 37.4244 47.0639 37.5528 47.0639Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 42.2488L18.9765 43.7128",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1035 43.7127L20.891 42.9807",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7637 44.9517L20.8902 46.3032",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9765 44.9518L18.6375 45.6268",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 14.8378L18.3 15.6778",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2571 15.6778L19.7641 14.9653",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9766 17.2453L19.7641 18.4288",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9625 17.2453L17.2305 18.1468",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6615 47.5273C65.6615 47.5273 65.9975 45.4018 64.928 45.4018C64.928 45.4018 64.8995 42.3043 65.477 41.6293C66.0545 40.9543 69.3335 40.4473 69.3335 40.4473C69.3335 40.4473 70.169 40.5043 70.562 41.6863C70.955 42.8683 70.673 44.2768 71.405 45.4033C72.137 46.5298 73.4315 47.1493 74.39 47.0638C75.3485 46.9783 76.5305 46.0498 77.516 45.9238C78.5015 45.7978 80.135 45.9103 81.035 47.0638C81.9365 48.2188 82.1045 51.7663 82.1045 51.7663",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9261 45.4018C64.9261 45.4018 64.0006 44.7853 63.9541 47.2843",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7081 21.9899H16.0611L14.9211 21.4259L14.2881 19.4594V14.6264L16.9491 12.4214L20.3706 10.1924L22.6506 6.13786C22.6506 6.13786 35.8266 1.70386 49.5111 1.70386C63.1956 1.70386 79.6596 3.35086 79.6596 3.35086L80.9046 5.37736L91.3221 6.64486C91.3221 6.64486 91.4481 7.78486 94.1091 7.15186C96.7701 6.51886 100.571 5.63086 100.571 5.63086H106.019C106.019 5.63086 109.82 6.51736 110.327 7.27786C110.834 8.03836 109.694 9.68536 109.694 9.68536L107.161 9.93886L109.568 12.9794C109.568 12.9794 90.8361 15.6809 81.4506 16.6739C72.0651 17.6669 59.8221 18.6899 59.8221 18.6899L63.7026 28.1669C63.7026 28.1669 65.0961 30.6734 65.0961 32.3429C65.0961 34.0124 65.0961 34.5554 63.9561 36.3734C62.8161 38.1914 62.4381 39.0719 62.3736 39.0749C62.3091 39.0779 70.5591 40.3454 70.5591 40.3454C70.5591 40.3454 71.2611 40.4714 71.6001 41.4854L71.9376 42.4994L90.2676 48.0749C90.2676 48.0749 90.8586 48.1589 90.0141 49.0889C89.1696 50.0174 88.4091 50.6939 88.4091 50.6939C88.4091 50.6939 88.3251 51.3689 86.2131 51.7079C84.1011 52.0454 81.8211 52.3829 81.8211 52.3829L87.0576 53.8184L86.8041 55.9304L87.5646 56.5214L84.8496 57.4499L73.7106 54.1559L72.8661 53.3954L66.1926 54.1559L65.5176 54.9164L64.0821 55.5914C64.0821 55.5914 58.5921 55.9289 50.8206 55.3379C43.0491 54.7469 26.8311 52.8884 24.2976 52.2119C24.2976 52.2119 22.1856 49.4249 20.4966 48.3269C18.8076 47.2289 16.5261 45.7934 15.7671 43.3439C15.0066 40.8944 15.8511 37.8539 15.8511 37.8539L16.9491 37.6844L18.0471 36.3719L19.2291 32.8694L20.7501 32.2784C20.7501 32.2784 20.8341 35.5679 21.4251 36.3719L29.3646 37.9379L28.0971 31.6034L27.7596 21.2984L28.0971 19.6934L21.0021 20.7044C21.0021 20.7044 20.3271 20.6474 20.3271 21.7754C20.3271 22.9034 20.4966 24.9299 20.4966 24.9299L19.9056 25.6859H18.8916L17.7096 21.9869L17.7081 21.9899Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6183 19.1877L29.1113 21.7767L29.6183 31.1817L31.3928 38.2767L35.1098 38.8677V37.8537L37.5593 37.9377L39.8393 36.8397L41.4563 36.7557C41.4563 36.7557 47.6948 39.1212 49.2998 39.3747C50.9048 39.6282 53.2703 39.7977 53.2703 39.7977C53.2703 39.7977 54.1148 33.6312 54.0308 32.3652C53.9468 31.0977 53.6933 30.0852 52.1723 26.6217C50.6513 23.1582 49.3853 20.7072 49.3853 20.7072H34.1813L32.2388 18.4287L29.6198 19.1892L29.6183 19.1877Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2369 18.4288L32.9119 15.8938L34.2634 13.4443L29.7874 11.1643L20.3689 10.1923",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2634 13.4443L35.3614 11.5858H45.4129L46.2574 13.0228L48.1159 13.4443L51.0724 10.5733L61.8844 10.1923L63.4894 11.8183H66.6154L67.2904 10.1923L76.8349 9.93877L77.5114 11.8183H81.0589L81.5659 10.9108L83.7619 10.1923L80.9044 5.37727",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0592 11.8184C81.0592 11.8184 82.8337 11.5859 82.8337 13.4444C82.8337 13.4444 67.2922 16.1474 65.3482 16.4849C63.4057 16.8224 50.2282 17.8664 50.2282 17.8664L48.1162 13.4444",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2283 17.8662L49.3838 20.7057",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9473 37.6873L32.4048 41.9953C32.4048 41.9953 32.7843 40.6018 33.4188 40.6018C34.0533 40.6018 54.0348 43.7698 54.0348 43.7698C54.0348 43.7698 53.8173 45.6703 57.4923 46.3033C61.1673 46.9363 70.5588 48.2038 70.5588 48.2038L66.1938 54.1588",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1341 53.1733C72.1341 53.1733 69.6561 52.7233 69.4311 52.6663C69.2061 52.6093 69.4311 51.8773 69.4311 51.8773L74.4426 51.3703L74.8371 52.2718L86.8041 55.9318",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8625 6.97314L97.0241 8.06664L90.886 9.13614C90.886 9.13614 91.6181 9.69864 90.3791 9.86814C89.1401 10.0376 86.5495 9.86814 86.5495 9.86814L85.3105 10.4876V11.3321H92.011L110.433 8.02914",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6155 11.8183H77.5115",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3945 49.0273H30.7155L34.263 47.0623L37.3035 49.0273H39.3315L40.599 50.7793H46.68L48.1155 49.5118L69.33 49.8778",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M48.116 49.5118L46.6805 47.9083H40.0925L39.332 49.0273",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2638 47.0624L32.4053 41.9954",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasmaRifle);
export default __webpack_public_path__ + "static/media/Plasma Rifle.b6b6ae8b9e31cf94bf8b60e013fa01fa.svg";
export { ForwardRef as ReactComponent };